import React from "react";
import "../styles/BlogStyles/BlogStyles.css";

const BlogPostDetail = () => {
  return (
    <article className="blog-detail-section py-5 bg-light">
      <div className="container bg-white p-0 rounded shadow-sm overflow-hidden content-container">
        
        {/* --- 1. Top Hero Image --- */}
        <div className="w-100">
          <img
            src="https://i.pinimg.com/1200x/b2/bc/92/b2bc92a31054fa6117dd8e9a2885e71a.jpg"
            alt="Global Career Concept"
            className="img-fluid w-100 object-fit-cover"
            style={{ maxHeight: "450px" }} 
          />
        </div>

        <div className="p-4 p-lg-5">
          {/* --- 2. Main Title --- */}
          <div className="mb-4">
            <h1 className="fw-bold text-purple display-6 mb-3">
              Go Global with Your Career – CPA, CMA (US) & EA Courses at Madhi Academy
            </h1>
          </div>

          {/* --- 3. Introduction --- */}
          <div className="blog-content text-secondary">
            <p className="mb-4 lead fs-6">
              In today's competitive job market, employers value <strong>global certifications</strong> that prove your expertise and open international opportunities. If you are an accounting, finance, or taxation professional looking to build a career beyond borders, <strong>Madhi Academy Chennai</strong> offers the right pathway through <strong>CPA (US), CMA (US), and EA courses</strong>.
            </p>

            {/* --- 4. Why Choose Global Certifications? --- */}
            <h4 className="fw-bold text-purple mb-4 mt-5">Why Choose Global Certifications?</h4>
            
            <div className="benefit-list mb-5">
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-globe text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">International Recognition</h6><p className="mb-0 small text-muted">Stand out in the global job market.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-currency-dollar text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">High Salary Potential</h6><p className="mb-0 small text-muted">Certified professionals are always in demand.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-briefcase-fill text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Mobility & Flexibility</h6><p className="mb-0 small text-muted">Opportunities across countries & industries.</p></div>
              </div>
              <div className="d-flex align-items-start mb-3">
                <div className="icon-circle-orange me-3 flex-shrink-0"><i className="bi bi-book-half text-white"></i></div>
                <div><h6 className="fw-bold text-dark mb-1">Specialized Knowledge</h6><p className="mb-0 small text-muted">Gain expertise in accounting, finance & taxation.</p></div>
              </div>
            </div>

            {/* --- 5. Our Global Professional Courses --- */}
            <h4 className="fw-bold text-purple mb-4">Our Global Professional Courses</h4>
            
            <div className="mb-4 p-4 bg-light rounded border-start border-4 border-purple">
              <h5 className="fw-bold text-dark">US CPA (Certified Public Accountant)</h5>
              <ul className="custom-list small-text mt-3">
                <li>Globally respected qualification in accounting & auditing.</li>
                <li>Covers <strong>Auditing, Financial Accounting, Regulation, Business Concepts</strong>.</li>
                <li>Best suited for accounting & finance professionals aiming for <strong>multinational careers</strong>.</li>
              </ul>
            </div>

            <div className="mb-4 p-4 bg-light rounded border-start border-4 border-purple">
              <h5 className="fw-bold text-dark">US CMA (Certified Management Accountant)</h5>
              <ul className="custom-list small-text mt-3">
                <li>Focuses on <strong>management accounting & strategic finance</strong>.</li>
                <li>Perfect for professionals seeking roles in <strong>corporate finance, business strategy & leadership</strong>.</li>
              </ul>
            </div>

            <div className="mb-5 p-4 bg-light rounded border-start border-4 border-purple">
              <h5 className="fw-bold text-dark">EA (Enrolled Agent – US Tax Expert)</h5>
              <ul className="custom-list small-text mt-3">
                <li>Specialization in <strong>US taxation laws</strong>.</li>
                <li>Authorized to represent taxpayers before the <strong>IRS</strong>.</li>
                <li>Excellent for those building a career in <strong>tax consultancy & compliance</strong>.</li>
              </ul>
            </div>

            {/* --- 6. Exam Process & Training Support --- */}
            <h4 className="fw-bold text-purple mb-3">Exam Process & Training Support</h4>
            <p className="mb-3">At <strong>Madhi Academy</strong>, we make your global certification journey smooth:</p>
            <ul className="mb-5 custom-list">
              <li>Step-by-step <strong>application & registration support</strong>.</li>
              <li><strong>Latest study materials</strong> with international syllabus coverage.</li>
              <li><strong>Mock tests & question banks</strong> for exam readiness.</li>
              <li><strong>Visa & placement assistance</strong> for global opportunities.</li>
            </ul>

            {/* --- 7. Career Benefits --- */}
            <h4 className="fw-bold text-purple mb-3">Career Benefits & Placement Support</h4>
            <ul className="mb-5 custom-list">
              <li>Global placement assistance with <strong>multinational firms</strong>.</li>
              <li>Networking events with industry experts.</li>
              <li>Personalized <strong>career counselling</strong> to guide your international career path.</li>
            </ul>

            {/* --- 8. Success Stories --- */}
            <div className="my-5">
              <h4 className="fw-bold text-purple mb-4">Student Success Stories</h4>
              <div className="row g-3">
                <div className="col-md-4">
                  <div className="p-3 border rounded h-100 bg-white shadow-sm">
                    <p className="small fst-italic mb-2">"I landed a job in Dubai after completing US CMA at Madhi Academy."</p>
                    <footer className="fw-bold text-purple small">– Shreya P</footer>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="p-3 border rounded h-100 bg-white shadow-sm">
                    <p className="small fst-italic mb-2">"The CPA training and career guidance here is top-notch."</p>
                    <footer className="fw-bold text-purple small">– Arjun M</footer>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="p-3 border rounded h-100 bg-white shadow-sm">
                    <p className="small fst-italic mb-2">"EA certification helped me build my own US tax consultancy."</p>
                    <footer className="fw-bold text-purple small">– Rahul S</footer>
                  </div>
                </div>
              </div>
            </div>

            {/* --- 9. FAQs --- */}
            <h4 className="fw-bold text-purple mb-3">FAQs</h4>
            <div className="mb-4">
              <p className="fw-bold mb-1 text-dark">Q: Do I need work experience to enroll?</p>
              <ul className="ps-3 mb-0 small text-muted" style={{ listStyleType: 'disc' }}>
                <li>US CMA requires <strong>2 years of relevant experience</strong>.</li>
                <li>CPA requires <strong>specific educational credits</strong>.</li>
                <li>EA has <strong>no minimum work experience</strong> requirement.</li>
              </ul>
            </div>
            <div className="mb-5">
              <p className="fw-bold mb-1 text-dark">Q: Can I work abroad after completing these courses?</p>
              <p className="text-muted small">Yes – provided you meet visa and local licensing requirements.</p>
            </div>

            {/* --- 10. Start Journey (Footer) --- */}
            <div className="border-top pt-4 mt-5">
              <h4 className="fw-bold text-purple mb-3 text-center">Start Your Global Journey Today</h4>
              <p className="text-center mb-4 small">
                Take the next step toward a <strong>global career in accounting, finance, and taxation</strong> with Madhi Academy’s <strong>CPA, CMA (US), and EA programs</strong>.
              </p>
              
              <div className="row justify-content-center">
                <div className="col-md-8 text-center">
                  <p className="mb-2 fw-bold text-dark">Madhi Academy – Global Courses Division</p>
                  <p className="mb-2 text-muted small">Nammalwarpet, Chennai, India</p>
                  
                  <div className="mt-3">
                    <a href="tel:+917708941960" className="btn btn-sm btn-outline-purple me-2 mb-2">
                      <i className="bi bi-telephone-fill me-1"></i> +91 77089 41960
                    </a>
                    <a href="mailto:admission@madhiacademy.com" className="btn btn-sm btn-outline-purple mb-2">
                      <i className="bi bi-envelope-fill me-1"></i> admission@madhiacademy.com
                    </a>
                  </div>
                  
                  <p className="mt-3 small text-muted">
                    <a href="https://global.madhiacademy.com" className="text-purple text-decoration-none fw-bold">global.madhiacademy.com</a>
                  </p>
                </div>
              </div>
              
              <p className="text-center mt-4 small text-muted fst-italic">
                If you’re searching for the <strong>best CPA training in Chennai, CMA US coaching institute, or EA certification course in India</strong>, Madhi Academy is your trusted partner for global success.
              </p>
            </div>

          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogPostDetail;